import { useCallback, useEffect, useState } from 'react';

export function useNewMessageDetection(messages, scrollToBottom) {
  const [isUserAtBottom, setIsUserAtBottom] = useState(true);
  const [showNewMessageButton, setShowNewMessageButton] = useState(false);
  const [lastMessageCount, setLastMessageCount] = useState(0);

  // 새 메시지 감지
  useEffect(() => {
    if (messages?.length > lastMessageCount && lastMessageCount > 0) {
      const newMessages = messages.slice(lastMessageCount);
      const hasNewNonMineMessage = newMessages.some(msg => !msg.isMine);

      if (isUserAtBottom) {
        // 사용자가 하단에 있으면 자동 스크롤
        setTimeout(() => {
          scrollToBottom();
        }, 100);
      } else if (hasNewNonMineMessage) {
        // 사용자가 하단에 없고 새 메시지가 있으면 알림 버튼 표시
        setShowNewMessageButton(true);
      }
    }
    setLastMessageCount(messages?.length || 0);
  }, [messages?.length, isUserAtBottom, lastMessageCount, scrollToBottom]);

  // 스크롤 위치 감지 핸들러
  const handleAtBottomStateChange = useCallback((atBottom) => {
    setIsUserAtBottom(atBottom);
    if (atBottom) {
      setShowNewMessageButton(false);
    }
  }, []);

  // 새 메시지 버튼 클릭 핸들러
  const handleNewMessageButtonClick = useCallback(() => {
    scrollToBottom();
    setShowNewMessageButton(false);
  }, [scrollToBottom]);

  return {
    isUserAtBottom,
    showNewMessageButton,
    handleAtBottomStateChange,
    handleNewMessageButtonClick
  };
}
